import { BranchStateService, IdsAdapterService, ProjectService } from '@alpha-core/platform-ui';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { lastValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';
import { User } from '../components/users/user.types';

export interface FetchAllGroupsQueryDto {
    pageSize?: number;
    pageNumber?: number;
    search?: string;
}

@Injectable({ providedIn: 'root' })
export class GroupService {
    private httpClient = inject(HttpClient);
    private router = inject(Router);
    private projectService = inject(ProjectService);
    private branchStateService = inject(BranchStateService);
    private idsAdapterService = inject(IdsAdapterService);

    groupPageSize!: number;

    getUsersByGroup(group: string, fetchActiveUsers: boolean = false) {
        return this.httpClient.post<User[]>(`${environment.ALPHA_UI_ADMIN_SERVICE_URL}/group/fetch-users`, {
            group,
            fetchActiveUsers,
        });
    }

    async createNewGroup(groupName: string, groupDescription: string) {
        try {
            const response = await lastValueFrom(
                this.httpClient.post(`${environment.ALPHA_UI_ADMIN_SERVICE_URL}/group/create`, {
                    group_name: groupName,
                    description: groupDescription,
                }),
            );
            this.idsAdapterService.invalidateGroupCache();
            return response;
        } catch (error) {
            console.error('Failed to create group', error);
            throw error;
        }
    }

    async updateGroup(id: number, groupName: string, groupDescription: string) {
        try {
            const response = await lastValueFrom(
                this.httpClient.post(`${environment.ALPHA_UI_ADMIN_SERVICE_URL}/group/update`, {
                    group_name: groupName,
                    description: groupDescription,
                    id,
                }),
            );
            this.idsAdapterService.invalidateGroupCache();
            return response;
        } catch (error) {
            console.error('Failed to update group', error);
            throw error;
        }
    }

    async deleteGroup(groupData: any) {
        try {
            const response = await lastValueFrom(
                this.httpClient.post(`${environment.ALPHA_UI_ADMIN_SERVICE_URL}/group/delete`, {
                    groupId: groupData.id,
                    group_name: groupData.group_name,
                }),
            );
            this.idsAdapterService.invalidateGroupCache();
            return response;
        } catch (error) {
            console.error('Failed to delete group', error);
            throw error;
        }
    }

    navigateTo(path: string[]) {
        const project = this.projectService.fetchCurrentProject();
        this.router.navigate(path, {
            queryParams: {
                projectId: project.projectId,
                branch: this.branchStateService.getBranch(),
            },
        });
    }
}
